<template>
<div :class="showSettle ? 'page_order page page_limit' : 'page_order page'">
    <van-tabs v-model="active" swipe-threshold="5" @click="onTabsClick">
        <van-tab title="待支付" name="1"></van-tab>
        <van-tab title="定制中" name="2"></van-tab>
        <van-tab title="待付尾款" name="3"></van-tab>
        <van-tab title="待收货" name="4"></van-tab>
        <van-tab title="已完成" name="5"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
		<!-- 订单状态 -->
        <van-list v-model="loading"  v-if="active != 6 && active != 7" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list" >
                <div class="item" v-for="(order,index) in orderList" :key="index" >
                    <div class="item_t" @click="goOrderDetail(order)">
                        <div class="item_t_t">
                            <img :src="(order.tradesman&&order.tradesman.thumb)? ( $publicData.withHttpStart(order.tradesman.thumb) ? order.tradesman.thumb : imageUrl+order.tradesman.thumb ) :$publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="title" v-if="order.tradesman">{{ order.tradesman.nickname }}</div>
                        </div>
                        <div class="status">{{ order.orderStatus }}</div>
                    </div>
                    <!-- 商品信息 -->
                    <div class="item_nr" @click="goOrderDetail(order)">
                        <div class="item_nr_l">
							<van-image :src="order.made.thumb?imageUrl+order.made.thumb:$publicData.intangibleDefault" class="tu" fit="contain"/>
                        </div>
                        <div class="item_nr_r dingzhi">
                            <div class="info">
                                <div class="title slh_s">{{ order.made.title }}</div>
                                <div class="desc slh">{{ order.made.descript }}</div>
                            </div>
                            <div class="jiage">预估价格: <span class="price">¥{{ order.made.price_range }}</span><span class="nums f-r">{{  order.num ? 'x'+order.num : 'x'+1 }}</span></div>
                        </div>
                    </div>
                    <div class="item_b">
                        <div class="sum"><span class="sum_r">定制价格：¥ <span class="total_price">{{ order.total_prices }}</span></span></div>
                        <div class="actions">
                            <!-- <div class="action" v-if="(order.order_status!=0&&order.pay_status==0) || (order.order_status!=0&&order.pay_status==1)" @click="toPay(order)">付款</div> -->
                            <div class="action" v-if="order.order_status==2&&order.pay_status==3&&order.made_status==2&&order.ship_status==1&&order.receipt_status==1&&order.comment_status==0" @click="commentorder(order)" >我要评论</div>
                            <div class="action" v-if="order.order_status==2&&order.pay_status==3&&order.made_status==2&&order.ship_status==1&&order.receipt_status==1&&order.comment_status==1" @click="commentorder(order)" >查看评论</div>
                            <div v-for="pay in order.payorder" :key="pay.id" >
                                <!-- <div class="action" v-if="pay.pay_status==0" @click="toPay(pay,order)">{{pay.type==1?'支付定金':'支付尾款'}}</div> -->
								<div class="action" v-if="pay.pay_status==0 && order.order_status != 0" @click="toAdvancePay(pay,order)">{{pay.type==1?'支付定金':'支付尾款'}}</div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
	<!-- 支付定金弹框 -->
	<van-overlay :show="showSettle" class-name="overlay">
		<div class="dingjin">
			<div class="top"></div>
			<div class="nr">
				<div class="nr_t">
					<img :src="publicPath+'statics/images/dingzhi/guize.png'" alt="" class="tu">
				</div>
				<div class="nr_m">
					<div class="">1、“定金”是平台根据匠人定制最终售价的一定比例所收首款，将作为本定制单交易开始的押金，交易达成后自动抵扣为订单费用；</div>
					<div class="">2、待定制作品完成后，平台将匠人按照用户需求匠心打造的作品照片发送至用户，并请用户进行“验收”；</div>
					<div class="">3、验收完成后，用户在平台进行“支付尾款”操作，如无特殊情况，平台将督促匠人于48小时内寄送出定制作品至用户地址接收处；</div>
					<div class="">4、用户收到定制作品后，如无质量问题，在平台进行“确认收货”操作，最终完成订单。</div>
				</div>
				<div class="nr_b">
					<div class="btn" @click="showSettle = false">取消</div>
					<div class="btn submit" @click="toPay(currentPay,currentOrder)">确定</div>
				</div>
			</div>
		</div>
	</van-overlay>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            page:1,
            size:10,
            orderList:[],
            finished: false,
            page: 1,
            size: 10,
            loading: false,
			refreshing: false,
			active: this.$route.query.status ? this.$route.query.status : '1',
            goNext: false,
			showSettle: false // 支付定金弹框
        };
    },
    created: function () {
		// console.log('this.active',this.active,typeof(this.active))
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '定制订单'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.onRefresh()
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            // this.onRefresh()
        }
	},
	mounted: function(){
		
	},
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.onRefresh();
		}
	},
    methods: {
        onTabsClick(name, title) {
            this.active = name
            this.onRefresh()
        },
        onRefresh() {
			// 清空列表数据
			this.finished = false;
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true;
			this.page = 1
			this.getData()
            
        },
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var token = this.$store.getters.token;
            var params = {
                token: this.token,
                page: this.page,
                size: this.size,
                status: this.active
            }
			this.$api.dingzhi.orderList(params).then(res=>{
				if(res.code == 200){
                    // this.orderList = res.result
                    var list = res.result
                    var old = this.orderList
                    if (this.page == 1) {
                        old = []
                    } 
                    for (let i = 0; i < list.length; i++) {
                        var order = list[i]
                        if (order.made  ) {
                            var album = order.made.album
							if(album){
								var images = album.split(",");
								if (images.length > 0) {
									order.made.thumb = images[0]
								} else {
									order.made.thumb = ''
								}
							}    
                        } else if (order.customizedcommunity) {
                            order.made = {
                                title: order.customizedcommunity.title,
                                descript:order.customizedcommunity.content,
                                price_range: order.customizedcommunity.price,
                                thumb: ''
                            }
                            var album = order.customizedcommunity.album
                            console.log(album)
							if(album){
								var images = album.split(",");
								if (images.length > 0) {
									order.made.thumb = images[0]
								} else {
									order.made.thumb = ''
								}
							}
                        }
                        if (order.order_status == 0) {
                            order.orderStatus = '已取消'
                        } else if (order.order_status == 2) {
                            if (order.comment_status ==1) {
                                order.orderStatus = '已完成'
                            } else {
                                order.orderStatus = '待评价'
                            }
                        } else if (order.pay_status == 0) {
                            order.orderStatus = '未付定金'
                        } else if (order.pay_status == 1) {
                            order.orderStatus = '支付中'
                        } else if (order.made_status == 1) {
                            order.orderStatus = '定制中'
                        } else if (order.pay_status == 2) {
                            order.orderStatus = '待付尾款'
                        } else if (order.receipt_status == 0) {
                            order.orderStatus = '待收货'
                        } else {
                            order.orderStatus = '已收货'
                        }
                        old.push(order)
                    }
                    this.orderList = old
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
				} else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
			})
		},
		// 去订单详情
		goOrderDetail(order){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/order/dingzhi/detail?id=' + order.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/order/dingzhi/detail',
                    query: {
                            id: order.id
                        }
                })
            }
		},
		// 支付前判断是否为支付定金,给确认框
		toAdvancePay(pay,order){
			var that = this
			if(pay.type == 1){
				// 支付定金
				that.showSettle = true
				that.currentPay = pay
				that.currentOrder = order
			}else{
				// 支付尾款
				that.toPay(pay,order)
			}
		},
        toPay(pay,order) {
            var pay_order_num = pay.pay_order_num
			var price = pay.total_prices
			var is_park = order.is_park == 1 ? 2 : 0 // 1 园区, 0 非园区, 支付页面 园区对应2
            var park_uuid = order.parktrades?order.parktrades.park_uuid:''
			// console.log(order.is_park)
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/pay?orderId=' + pay_order_num + '&price=' + price + '&isPlatprice='+ is_park +'&type=made&park_uuid='+park_uuid+'&is_chargecard='+order.made.is_chargecard
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/shop/pay',
                    query: {
                        orderId: pay_order_num,
                        price: price,
                        isPlatprice: is_park, 
                        is_chargecard: order.made.is_chargecard,
						type:'made',
						dingzhi_status: pay.type, // 1 待付定金, 2 待付尾款
                        park_uuid: park_uuid
                    }
                })
            }
		},
        commentorder(order) {
            if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                var params = {
                    'data':{
                        'url':this.$publicData.clientUrl+'/dingzhi/comment?orderId='+order.order_num+'&madeId='+order.made.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/dingzhi/comment',
                    query: {
                            orderId: order.order_num,
                            madeId: order.made.id
                        }
                })
            }
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
